import { named, withDependencies } from '@wix/thunderbolt-ioc'
import type { ISessionManager } from 'feature-session-manager'
import { METASITE_APP_DEF_ID, SiteFeatureConfigSymbol } from '@wix/thunderbolt-symbols'
import type { ServiceProvider } from '@wix/thunderbolt-symbols'
import type { ICommonConfig } from 'feature-common-config'
import { CommonConfigSymbol } from 'feature-common-config'
import { name } from './symbols'
import type { ConsentPolicyCarmiConfig } from './types'
import {
	ConsentPolicyDefinition as definition,
	type IConsentPolicyDefinition,
} from '@wix/viewer-service-consent-policy/definition'
import {
	ConsentPolicyService as impl,
	injectAccessTokenGetter,
} from '@wix/viewer-service-consent-policy/implementations'
import { SessionManagerSymbol } from 'feature-session-manager'

export const ConsentPolicyService = withDependencies(
	[CommonConfigSymbol, named(SiteFeatureConfigSymbol, name), SessionManagerSymbol],
	(
		commonConfig: ICommonConfig,
		consentPolicyConfig: ConsentPolicyCarmiConfig,
		sessionManager: ISessionManager
	): ServiceProvider<IConsentPolicyDefinition, typeof impl> => {
		const config = {
			...consentPolicyConfig,
			updateCommonConfig: commonConfig.updateCommonConfig,
		}
		const tokenGetter = sessionManager.getBoundAccessTokenFunction(METASITE_APP_DEF_ID)
		injectAccessTokenGetter(tokenGetter)
		return {
			definition,
			impl,
			config,
			platformConfig: {},
		}
	}
)

export { definition, impl }
